export default "<p>edit-attachment works!</p>\n";